module.exports = __webpack_public_path__ + "static/media/brand-logo-light-no-tagline.62acc7be.png";